// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Axis from "@visx/axis";
import * as Grid from "@visx/grid";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_int32 from "rescript/lib/es6/caml_int32.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Curve from "@visx/curve";
import * as Scale from "@visx/scale";
import * as Shape from "@visx/shape";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as Tooltip from "@visx/tooltip";
import * as PositionCircle from "common/src/components/PositionCircle.bs.js";
import Format from "date-fns/format";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";
import * as PlChartPosCircle from "./PlChartPosCircle.bs.js";
import AddDays from "date-fns/addDays";
import GetDate from "date-fns/getDate";
import GetMonth from "date-fns/getMonth";
import StartOfDay from "date-fns/startOfDay";

function getXTicks(matches) {
  var ticks = [];
  var revMatches = Belt_Array.reverse(matches);
  var startDate = StartOfDay(new Date(Belt_Array.getExn(revMatches, 0).dateTime));
  ticks.push([
        0,
        startDate
      ]);
  var rd = startDate;
  var loop = true;
  while(loop) {
    var d = AddDays(rd, 1);
    rd = d;
    var idx = revMatches.findIndex((function(d){
        return function (m) {
          return m.dateTime > d.getTime();
        }
        }(d)));
    if (idx === -1) {
      loop = false;
    } else if (Belt_Array.some(ticks, (function(idx){
          return function (param) {
            return param[0] === idx;
          }
          }(idx)))) {
      Belt_Array.set(ticks, ticks.length - 1 | 0, [
            idx,
            d
          ]);
    } else {
      ticks.push([
            idx,
            d
          ]);
    }
  };
  return ticks;
}

function getDelta(place, screenSize) {
  var base = screenSize !== 4 ? (
      screenSize >= 5 ? 6 : 9
    ) : 7;
  var coeff = screenSize !== 4 ? (
      screenSize >= 5 ? 1.5 : 2.25
    ) : 1.75;
  return (
          place <= 4 ? -base : base
        ) + (Global.f(place) - 4.5) * coeff;
}

function parseData(games, set) {
  var lastGameDate = {
    contents: undefined
  };
  var gameData = [];
  var dayIdxs = [];
  var breaks = [];
  var currBatch = {
    contents: []
  };
  var currIdx = {
    contents: -1
  };
  var lastRankAfter = {
    contents: Belt_Array.getExn(games, 0).rankBefore
  };
  var revGames = Belt_Array.reverse(games);
  var firstRankedGame = revGames.findIndex(function (g) {
        return Belt_Option.isSome(g.rankBefore);
      });
  var revGames$1 = Belt_Array.sliceToEnd(revGames, Caml.caml_int_max(firstRankedGame - 1 | 0, 0));
  Belt_Array.forEach(revGames$1, (function (game) {
          var date = new Date(game.dateTime - 4 * 60 * 60 * 1000);
          var lastDate = lastGameDate.contents;
          var newDay;
          if (lastDate !== undefined) {
            var lastDate$1 = Caml_option.valFromOption(lastDate);
            newDay = GetDate(lastDate$1) !== GetDate(date) || GetMonth(lastDate$1) !== GetMonth(date);
          } else {
            newDay = false;
          }
          lastGameDate.contents = Caml_option.some(date);
          var prevIdx = currIdx.contents;
          var idx = currIdx.contents + (
            newDay ? 1.5 : 1
          );
          if (newDay) {
            dayIdxs.push([
                  currIdx.contents + 0.75,
                  date
                ]);
          }
          var endRank = Belt_Option.getExn(game.rankAfter);
          if (Caml_obj.caml_equal(game.rankBefore, lastRankAfter.contents) || idx === 0) {
            currBatch.contents.push([
                  idx,
                  LpChartUtils.divisionToBase(endRank[0], set) + endRank[1] | 0
                ]);
          } else {
            var startRank = game.rankBefore;
            if (startRank !== undefined) {
              breaks.push([
                    prevIdx,
                    Belt_Option.getExn(lastRankAfter.contents),
                    startRank
                  ]);
              gameData.push(currBatch.contents);
              currBatch.contents = [
                [
                  prevIdx,
                  LpChartUtils.divisionToBase(startRank[0], set) + startRank[1] | 0
                ],
                [
                  idx,
                  LpChartUtils.divisionToBase(endRank[0], set) + endRank[1] | 0
                ]
              ];
            }
            
          }
          currIdx.contents = idx;
          lastRankAfter.contents = game.rankAfter;
          
        }));
  if (currBatch.contents.length !== 0) {
    gameData.push(currBatch.contents);
  }
  return [
          dayIdxs,
          gameData,
          breaks
        ];
}

function PlGamesChart(Props) {
  var matches = Props.matches;
  var onShowDetails = Props.onShowDetails;
  var padLeft = Props.padLeft;
  var chartWidth = Props.chartWidth;
  var chartHeight = Props.chartHeight;
  var masterRanks = Props.masterRanks;
  var isDuo = Props.isDuo;
  var set = TftSet.use(undefined);
  var masterLp = set === 10 || set >= 100 ? 2800 : 2400;
  var matches$1 = Belt_Array.keep(matches, (function (m) {
          return Belt_Option.isSome(m.rankAfter);
        }));
  var match = React.useMemo((function () {
          return parseData(matches$1, set);
        }), [matches$1]);
  var groupedData = match[1];
  var dayIdxs = match[0];
  var data = Belt_Array.concatMany(Belt_Array.mapWithIndex(groupedData, (function (idx, data) {
              if (idx === 0) {
                return data;
              } else {
                return Belt_Array.sliceToEnd(data, 1);
              }
            })));
  var tooltip = Tooltip.useTooltip();
  var screenSize = ScreenAtom.use(undefined);
  var compact = ScreenAtom.isMobile(screenSize);
  var minRank = Caml_splice_call.spliceApply(Math.min, [Belt_Array.map(data, (function (prim) {
                return prim[1];
              }))]);
  var maxRank = Caml_splice_call.spliceApply(Math.max, [Belt_Array.map(data, (function (prim) {
                return prim[1];
              }))]);
  var match$1 = LpChartUtils.getYTicks(minRank, maxRank);
  var maxRank$1 = match$1[2];
  var minRank$1 = match$1[1];
  var yTicks = match$1[0];
  var maxX = Belt_Array.getExn(data, data.length - 1 | 0)[0];
  var xScale = Scale.scaleLinear({
        range: [
          0,
          Global.f(chartWidth)
        ],
        domain: [
          -1,
          maxX
        ]
      });
  var xScaleRev = Scale.scaleLinear({
        range: [
          -1,
          maxX
        ],
        domain: [
          0,
          Global.f(chartWidth)
        ]
      });
  var yScaleFull = Scale.scaleLinear({
        range: [
          Global.f(chartHeight),
          0
        ],
        domain: [
          Global.f(minRank$1),
          Global.f(maxRank$1)
        ]
      });
  var startRank = Belt_Array.getExn(matches$1, matches$1.length - 1 | 0).rankBefore;
  Belt_Array.getExn(matches$1, matches$1.length - 1 | 0).dateTime;
  Belt_Array.getExn(matches$1, 0).dateTime;
  var timeData = Belt_Array.mapWithIndex(data, (function (idx, param) {
          var hp = Belt_Array.getExn(matches$1, (data.length - 1 | 0) - idx | 0);
          return [
                  param[0],
                  hp
                ];
        }));
  var challPath = Belt_Option.flatMap(masterRanks, (function (mr) {
          var challLps = Belt_Array.map(mr.challenger, (function (param) {
                  return param[1] + masterLp | 0;
                }));
          var minLp = Caml_splice_call.spliceApply(Math.min, [challLps]);
          var maxLp = Caml_splice_call.spliceApply(Math.max, [challLps]);
          if (!(minLp < maxRank$1 && maxLp > minRank$1)) {
            return ;
          }
          var firstIndex = {
            contents: undefined
          };
          var data = [];
          Belt_Array.forEach(timeData, (function (param) {
                  var hp = param[1];
                  var idx = mr.challenger.findIndex(function (param) {
                        return param[0] < hp.dateTime / 1000;
                      });
                  if (idx < 0) {
                    return ;
                  }
                  var match = Belt_Array.getExn(mr.challenger, idx);
                  data.push([
                        param[0],
                        match[1] + masterLp | 0
                      ]);
                  var match$1 = firstIndex.contents;
                  if (match$1 !== undefined) {
                    return ;
                  } else {
                    firstIndex.contents = idx;
                    return ;
                  }
                }));
          var idx = firstIndex.contents;
          var data$1;
          if (idx !== undefined && idx !== 0) {
            var match = Belt_Array.getExn(mr.challenger, idx);
            data$1 = Belt_Array.concat([[
                    -1,
                    match[1] + masterLp | 0
                  ]], data);
          } else {
            data$1 = data;
          }
          return Belt_Array.keep(data$1, (function (param) {
                        var lp = param[1];
                        if (lp >= minRank$1) {
                          return lp <= maxRank$1;
                        } else {
                          return false;
                        }
                      }));
        }));
  var gmPath = Belt_Option.flatMap(masterRanks, (function (mr) {
          var gmLps = Belt_Array.map(mr.grandmaster, (function (param) {
                  return param[1] + masterLp | 0;
                }));
          var minLp = Caml_splice_call.spliceApply(Math.min, [gmLps]);
          var maxLp = Caml_splice_call.spliceApply(Math.max, [gmLps]);
          if (!(minLp < maxRank$1 && maxLp > minRank$1)) {
            return ;
          }
          var firstIndex = {
            contents: undefined
          };
          var data = [];
          Belt_Array.forEach(timeData, (function (param) {
                  var hp = param[1];
                  var idx = mr.grandmaster.findIndex(function (param) {
                        return param[0] < hp.dateTime / 1000;
                      });
                  if (idx < 0) {
                    return ;
                  }
                  var match = Belt_Array.getExn(mr.grandmaster, idx);
                  data.push([
                        param[0],
                        match[1] + masterLp | 0
                      ]);
                  var match$1 = firstIndex.contents;
                  if (match$1 !== undefined) {
                    return ;
                  } else {
                    firstIndex.contents = idx;
                    return ;
                  }
                }));
          var idx = firstIndex.contents;
          var data$1;
          if (idx !== undefined && idx !== 0) {
            var match = Belt_Array.getExn(mr.grandmaster, idx);
            data$1 = Belt_Array.concat([[
                    -1,
                    match[1] + masterLp | 0
                  ]], data);
          } else {
            data$1 = data;
          }
          return Belt_Array.keep(data$1, (function (param) {
                        var lp = param[1];
                        if (lp >= minRank$1) {
                          return lp <= maxRank$1;
                        } else {
                          return false;
                        }
                      }));
        }));
  var prevMonthLabel = {
    contents: -1
  };
  var positionIndicator = Caml_int32.div(chartWidth, matches$1.length) >= 22 ? /* Circle */1 : /* Dot */0;
  var svgWidth = (padLeft + chartWidth | 0) + 10 | 0;
  var svgHeight = (20 + chartHeight | 0) + 41 | 0;
  var tmp;
  if (tooltip.tooltipOpen) {
    var idx = Curry._1(xScaleRev, tooltip.tooltipLeft - Global.f(padLeft));
    var xIdxs = Belt_Array.map(Belt_Array.map(data, (function (prim) {
                return prim[0];
              })), (function (x) {
            return Math.abs(x - idx);
          }));
    var minXIdx = Caml_splice_call.spliceApply(Math.min, [xIdxs]);
    var idx$1 = xIdxs.indexOf(minXIdx);
    var match$2 = Belt_Array.getExn(data, idx$1);
    var left = Curry._1(xScale, match$2[0]);
    tmp = React.createElement("line", {
          stroke: "rgba(255, 255, 255, 0.55)",
          strokeDasharray: "4,4",
          strokeWidth: "1.75",
          x1: left.toString(),
          x2: left.toString(),
          y1: "0",
          y2: String(chartHeight)
        });
  } else {
    tmp = null;
  }
  var tmp$1;
  if (tooltip.tooltipOpen) {
    var idx$2 = Curry._1(xScaleRev, tooltip.tooltipLeft - Global.f(padLeft));
    var xIdxs$1 = Belt_Array.map(Belt_Array.map(data, (function (prim) {
                return prim[0];
              })), (function (x) {
            return Math.abs(x - idx$2);
          }));
    var minXIdx$1 = Caml_splice_call.spliceApply(Math.min, [xIdxs$1]);
    var idx$3 = xIdxs$1.indexOf(minXIdx$1);
    var match$3 = Belt_Array.getExn(data, idx$3);
    var xIdx = match$3[0];
    var left$1 = Curry._1(xScale, xIdx);
    var match$4 = LpChartUtils.ratingToDivisionFull(match$3[1], set);
    var lp = match$4[1];
    var div = match$4[0];
    var content = div === "Master" ? String(lp) + " LP" : div + " " + String(lp) + "LP";
    var gmRank = Belt_Option.flatMap(gmPath, (function (gmPath) {
            return Caml_option.undefined_to_opt(Belt_Array.reverse(gmPath).find(function (param) {
                            return xIdx >= param[0];
                          }));
          }));
    var challRank = Belt_Option.flatMap(challPath, (function (challPath) {
            return Caml_option.undefined_to_opt(Belt_Array.reverse(challPath).find(function (param) {
                            return xIdx >= param[0];
                          }));
          }));
    tmp$1 = React.createElement(Tooltip.TooltipWithBounds, {
          left: left$1 + Global.f(padLeft),
          top: tooltip.tooltipTop + 14,
          className: "absolute top-0 left-0 py-2 px-[10px] bg-primary-4 rounded elevation-8",
          unstyled: true,
          children: React.createElement("div", {
                className: "flex flex-col gap-1 text-white1 text-xs sm:text-sm"
              }, React.createElement("div", {
                    className: "flex"
                  }, React.createElement("div", {
                        className: "pr-2"
                      }, React.createElement("div", {
                            className: "flex items-center w-12"
                          }, React.createElement("div", {
                                className: CssJs.style([
                                      CssJs.width(CssJs.px(8)),
                                      CssJs.height(CssJs.px(8)),
                                      CssJs.unsafe("background", LpChartUtils.rankColor),
                                      CssJs.marginRight(CssJs.px(4))
                                    ])
                              }), "Rank")), React.createElement("div", undefined, React.createElement("div", undefined, content))), challRank !== undefined ? React.createElement("div", {
                      className: "flex"
                    }, React.createElement("div", {
                          className: "pr-2"
                        }, React.createElement("div", {
                              className: "flex items-center w-12"
                            }, React.createElement("div", {
                                  className: "w-[8px] h-[8px] mr-1 bg-amber-9"
                                }), "C")), React.createElement("div", undefined, String(challRank[1] - masterLp | 0) + " LP")) : null, gmRank !== undefined ? React.createElement("div", {
                      className: "flex"
                    }, React.createElement("div", {
                          className: "pr-2"
                        }, React.createElement("div", {
                              className: "flex items-center w-12"
                            }, React.createElement("div", {
                                  className: "w-[8px] h-[8px] mr-1 bg-red-9"
                                }), "GM")), React.createElement("div", undefined, String(gmRank[1] - masterLp | 0) + " LP")) : null),
          key: Math.random().toString()
        });
  } else {
    tmp$1 = null;
  }
  return React.createElement(React.Fragment, undefined, React.createElement("svg", {
                  className: CssJs.style([CssJs.width(CssJs.px(svgWidth))]),
                  viewBox: "0 0 " + String(svgWidth) + " " + String(svgHeight)
                }, React.createElement("g", {
                      onMouseLeave: (function (param) {
                          tooltip.hideTooltip();
                          
                        }),
                      onMouseMove: (function (e) {
                          tooltip.showTooltip({
                                tooltipLeft: e.nativeEvent.offsetX,
                                tooltipTop: e.nativeEvent.offsetY,
                                tooltipData: undefined
                              });
                          
                        }),
                      transform: "translate(" + String(padLeft) + ", " + String(20) + ")"
                    }, React.createElement("rect", {
                          height: String((20 + chartHeight | 0) + 41 | 0),
                          width: String((padLeft + chartWidth | 0) + 10 | 0),
                          fill: "transparent",
                          x: String(-padLeft | 0),
                          y: String(-20)
                        }), React.createElement(Grid.GridRows, {
                          top: 0,
                          left: 0,
                          scale: yScaleFull,
                          stroke: "rgba(255, 255, 255, 0.24)",
                          width: chartWidth,
                          height: chartHeight,
                          numTicks: 5,
                          tickValues: yTicks
                        }), React.createElement(Grid.GridColumns, {
                          top: 0,
                          left: 0,
                          scale: xScale,
                          stroke: "rgba(255, 255, 255, 0.24)",
                          width: chartWidth,
                          height: chartHeight,
                          numTicks: 8,
                          tickValues: Belt_Array.map(dayIdxs, (function (x) {
                                  return x[0];
                                })),
                          strokeDasharray: "12 8"
                        }), React.createElement(Grid.GridRows, {
                          top: 0,
                          left: 0,
                          scale: yScaleFull,
                          stroke: "rgba(255, 255, 255, 0.5)",
                          width: chartWidth,
                          height: chartHeight,
                          tickValues: Belt_Array.map(Belt_Array.keep([
                                    400,
                                    800,
                                    1200,
                                    1600,
                                    2000,
                                    2400,
                                    2800
                                  ], (function (r) {
                                      if (r >= minRank$1) {
                                        return r <= maxRank$1;
                                      } else {
                                        return false;
                                      }
                                    })), Global.f)
                        }), React.createElement(Axis.AxisLeft, {
                          top: 0,
                          left: 0,
                          scale: yScaleFull,
                          numTicks: 5,
                          stroke: "white",
                          tickValues: yTicks,
                          tickStroke: "white",
                          tickFormat: (function (v) {
                              var match = LpChartUtils.ratingToDivision(v | 0, set);
                              var lp = match[1];
                              var div = match[0];
                              if (div === "M" && lp !== 0) {
                                return String(lp);
                              } else {
                                return div;
                              }
                            }),
                          tickLabelProps: (function (param) {
                              return LpChartUtils.tickLabelPropsLeft(screenSize, set, param);
                            })
                        }), React.createElement(Axis.AxisBottom, {
                          top: chartHeight,
                          left: 0,
                          scale: xScale,
                          numTicks: 8,
                          stroke: "white",
                          tickValues: Belt_Array.map(dayIdxs, (function (x) {
                                  return x[0];
                                })),
                          tickStroke: "white",
                          tickFormat: (function (v) {
                              return Belt_Option.getExn(Caml_option.undefined_to_opt(dayIdxs.find(function (param) {
                                                    return param[0] === v;
                                                  })))[1];
                            }),
                          tickLabelProps: (function (param) {
                              return LpChartUtils.tickLabelPropsBottom(screenSize, param);
                            }),
                          tickComponent: (function (props) {
                              var d = props.formattedValue;
                              return React.createElement(React.Fragment, undefined, React.createElement("text", {
                                              dy: "0.25em",
                                              fill: LpChartUtils.rankColor,
                                              fontSize: "12",
                                              textAnchor: "middle",
                                              x: props.x.toFixed(2),
                                              y: props.y.toFixed(2)
                                            }, String(GetDate(d))), prevMonthLabel.contents !== GetMonth(d) ? (prevMonthLabel.contents = GetMonth(d), React.createElement("text", {
                                                  dy: "1.5em",
                                                  fill: LpChartUtils.rankColor,
                                                  fontSize: "12",
                                                  textAnchor: "middle",
                                                  x: props.x.toFixed(2),
                                                  y: props.y.toFixed(2)
                                                }, Format(d, "MMM"))) : null);
                            })
                        }), tmp, gmPath !== undefined ? React.createElement(Shape.LinePath, {
                            opacity: "0.8",
                            strokeDasharray: "3 7",
                            strokeWidth: 1.5,
                            data: gmPath,
                            x: (function (param, param$1) {
                                var idx = param[0];
                                return Curry._1(xScale, idx === 0 ? 0 : idx);
                              }),
                            y: (function (param) {
                                return Curry._1(yScaleFull, Global.f(param[1]));
                              }),
                            stroke: "var(--red-9)",
                            curve: Curve.curveCatmullRom
                          }) : null, challPath !== undefined ? React.createElement(Shape.LinePath, {
                            opacity: "0.8",
                            strokeDasharray: "3 7",
                            strokeWidth: 1.5,
                            data: challPath,
                            x: (function (param, param$1) {
                                var idx = param[0];
                                return Curry._1(xScale, idx === 0 ? 0 : idx);
                              }),
                            y: (function (param) {
                                return Curry._1(yScaleFull, Global.f(param[1]));
                              }),
                            stroke: "var(--amber-9)",
                            curve: Curve.curveCatmullRom
                          }) : null, Belt_Array.mapWithIndex(groupedData, (function (idx, data) {
                            var data$1 = idx === 0 && startRank !== undefined ? Belt_Array.concat([[
                                      -1,
                                      LpChartUtils.divisionToBase(startRank[0], set) + startRank[1] | 0
                                    ]], data) : data;
                            return React.createElement(Shape.LinePath, {
                                        strokeWidth: 1.5,
                                        data: data$1,
                                        x: (function (param, param$1) {
                                            var idx = param[0];
                                            return Curry._1(xScale, idx === 0 ? 0 : idx);
                                          }),
                                        y: (function (param) {
                                            return Curry._1(yScaleFull, Global.f(param[1]));
                                          }),
                                        stroke: LpChartUtils.rankColor,
                                        curve: Curve.curveCatmullRom,
                                        key: String(idx)
                                      });
                          })), Belt_Array.map(match[2], (function (param) {
                            var after = param[2];
                            var before = param[1];
                            var idx = param[0];
                            var before$1 = LpChartUtils.divisionToBase(before[0], set) + before[1] | 0;
                            var after$1 = LpChartUtils.divisionToBase(after[0], set) + after[1] | 0;
                            return React.createElement(Shape.Line, {
                                        strokeDasharray: "5 3",
                                        stroke: LpChartUtils.rankColor,
                                        from: {
                                          x: Curry._1(xScale, idx),
                                          y: Curry._1(yScaleFull, Global.f(before$1))
                                        },
                                        to: {
                                          x: Curry._1(xScale, idx),
                                          y: Curry._1(yScaleFull, Global.f(after$1))
                                        },
                                        strokeWidth: 1.5,
                                        key: Global.toFixed(undefined, idx)
                                      });
                          })), Belt_Array.mapWithIndex(data, (function (idx, param) {
                            var d = param[1];
                            var xIdx = param[0];
                            var hp = Belt_Array.getExn(matches$1, (data.length - 1 | 0) - idx | 0);
                            var place = hp.info.placement;
                            var renderPlace = isDuo ? (place + 1 | 0) / 2 | 0 : place;
                            var delta = getDelta(place, screenSize);
                            var tmp;
                            if (positionIndicator) {
                              var left = Curry._1(xScale, xIdx) - (
                                screenSize !== 4 ? (
                                    screenSize >= 5 ? 7.5 : 12
                                  ) : 10.5
                              );
                              var top = Curry._1(yScaleFull, Global.f(d)) + (
                                place > 4 ? delta + (
                                    screenSize !== 4 ? (
                                        screenSize >= 5 ? 7.5 : 0
                                      ) : 3.5
                                  ) : -22 + (
                                    screenSize !== 4 ? (
                                        screenSize >= 5 ? 7.5 : 0
                                      ) : 3.5
                                  ) + delta
                              );
                              tmp = React.createElement(React.Fragment, undefined, React.createElement("line", {
                                        stroke: "#" + PositionCircle.placeColor(renderPlace),
                                        strokeWidth: "1.75",
                                        x1: Curry._1(xScale, xIdx).toFixed(),
                                        x2: Curry._1(xScale, xIdx).toFixed(),
                                        y1: (Curry._1(yScaleFull, Global.f(d)) + delta).toFixed(),
                                        y2: Curry._1(yScaleFull, Global.f(d)).toFixed()
                                      }), React.createElement("g", {
                                        className: "cursor-pointer",
                                        onClick: (function (param) {
                                            return Curry._1(onShowDetails, hp.id);
                                          }),
                                        transform: "translate(" + Global.toFixed(undefined, left) + ", " + Global.toFixed(undefined, top) + ")"
                                      }, React.createElement("circle", {
                                            cx: compact ? "9.5" : "11",
                                            cy: compact ? "9.5" : "11",
                                            fill: "transparent",
                                            r: compact ? "11.5" : "13"
                                          }), React.createElement(PlChartPosCircle.make, {
                                            size: screenSize !== 4 ? (
                                                screenSize >= 5 ? 14 : 24
                                              ) : 20,
                                            pl: renderPlace
                                          })));
                            } else {
                              tmp = null;
                            }
                            return React.createElement(React.Fragment, {
                                        children: null,
                                        key: String(idx)
                                      }, React.createElement("circle", {
                                            cx: Curry._1(xScale, xIdx).toFixed(),
                                            cy: Curry._1(yScaleFull, Global.f(d)).toFixed(),
                                            fill: "#" + PositionCircle.placeColor(renderPlace),
                                            r: positionIndicator === /* Dot */0 ? "3" : "4"
                                          }), tmp);
                          })))), tmp$1);
}

var padRight = 10;

var padTop = 20;

var padBottom = 41;

var make = PlGamesChart;

export {
  getXTicks ,
  getDelta ,
  parseData ,
  padRight ,
  padTop ,
  padBottom ,
  make ,
  
}
/* CssJs Not a pure module */
